import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
import { ChartSkeleton } from '@repo/ui';

/**
 * Plot box drawn by Highcharts with useHighchartsOptions' `margin: [1, 1, 30, 1]` and SimpleChart's
 * 1px plot border: the border straddles the plot edge, so it starts at the top and the x-axis labels take 29px.
 */
const CHART_SKELETON_MARGIN = {
  top: 0,
  bottom: 29
};
const CHART_SKELETON_BORDER_WIDTH = 1;
/** Highcharts puts the 11px x-axis labels 10px below the 5px ticks; a 13px gap centres the 8px label stub on that text. */
const CHART_SKELETON_X_LABEL_GAP = 13;
export const CHART_SKELETON_GEOMETRY = {
  plotMargin: CHART_SKELETON_MARGIN,
  plotBorderWidth: CHART_SKELETON_BORDER_WIDTH,
  xLabelGap: CHART_SKELETON_X_LABEL_GAP
};
export interface ChartStatusLoadingProps {
  /** Corner radius (px) of the skeleton — matches the rendered chart's radius. */
  borderRadius: number;
  hideXAxis?: boolean;
  /** Axis-less sparklines (dashboard cards) keep a flat block: no y-axis stubs or plot border to draw. */
  hideYAxis?: boolean;
}
function ChartStatusLoading(t0) {
  const $ = _c(10);
  const {
    borderRadius,
    hideXAxis,
    hideYAxis
  } = t0;
  if (hideYAxis) {
    const t1 = hideXAxis ? "h-full" : "mb-[29px]";
    let t2;
    if ($[0] !== t1) {
      t2 = cn("w-full", t1);
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const t3 = `${borderRadius}px`;
    let t4;
    if ($[2] !== t3) {
      t4 = {
        borderRadius: t3
      };
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== t2 || $[5] !== t4) {
      t5 = <Skeleton className={t2} style={t4} />;
      $[4] = t2;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  let t1;
  if ($[7] !== borderRadius || $[8] !== hideXAxis) {
    t1 = <ChartSkeleton plotRadius={borderRadius} hideXAxis={hideXAxis} {...CHART_SKELETON_GEOMETRY} />;
    $[7] = borderRadius;
    $[8] = hideXAxis;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
export default ChartStatusLoading;